CarouselVue(data-test='carousel' :total='exclusives.length' @index-updated='index => setCurrentIndex(index.value)')
  .fp-slider--image(v-for='(exclusive, index) in exclusives' :key='index' :class='{"-active": index === currentIndex}' :data-test='`carousel.image-${index}`')
    router-link.fp-link.-no-text-decoration(:to='{ name: \'exclusiveDetail\', params: { exclusiveSlug: exclusive.slug } }')
      PresentationCardVue(:exclusive='exclusive' :show-like='showLike')
